<template>
    <div class="temperature-view">
      <h2>온도 모니터링</h2>
      <LineChart />
    </div>
  </template>
  
  <script>
  import LineChart from '@/components/LineChart.vue'
  
  export default {
    name: 'TemperatureView', // 이름을 multi-word로 변경
    components: {
      LineChart
    }
  }
  </script>
  
  <style scoped>
  .temperature-view {
    padding: 20px;
  }
  
  h2 {
    margin-bottom: 20px;
  }
  </style>